/**
 * @generated SignedSource<<884436a8e785d5809a558714a86cf90c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type templatePreviewRelayFragment$data = {
  readonly name: string | null | undefined;
  readonly templatePreviews: ReadonlyArray<{
    readonly url: string;
  }> | null | undefined;
  readonly templateType: ReadonlyArray<{
    readonly id: string;
  }> | null | undefined;
  readonly " $fragmentType": "templatePreviewRelayFragment";
};
export type templatePreviewRelayFragment$key = {
  readonly " $data"?: templatePreviewRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"templatePreviewRelayFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "templatePreviewRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentPlatformTaxonomyTemplateType",
      "kind": "LinkedField",
      "name": "templateType",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "templatePreviews",
      "args": null,
      "concreteType": "ContentPlatformTemplateImageAsset",
      "kind": "LinkedField",
      "name": "templatePreview",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentPlatformTemplate",
  "abstractKey": null
};

(node as any).hash = "e15cf739a764eb84e14a1006034c2387";

export default node;
